import useSWR from "swr";
import { useSWRFetcher } from "./useSWRFetcher";
import { environment } from "../config/environment";

export type LanguageModel = {
  id: string;
  name: string;
};

export const useLanguages = () => {
  const fetcher = useSWRFetcher();

  const { data, isLoading, error } = useSWR<LanguageModel[]>(
    `${environment.apiUrl}/api/languages`,
    (url: string) => fetcher(url),
    {}
  );

  return {
    languages: data,
    isLoading,
    error,
  };
};
